// src/components/CounterSection.jsx
import React, { useState, useEffect, useRef } from "react";
import "./CounterSection.css";

const CounterItem = ({ end, label, suffix = "+", duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef(null);
  const observer = useRef(null);

  useEffect(() => {
    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            startCounter();
          }
        });
      },
      { threshold: 0.5 },
    );

    if (ref.current) {
      observer.current.observe(ref.current);
    }

    return () => {
      if (observer.current && ref.current) {
        observer.current.unobserve(ref.current);
      }
    };
  }, [hasAnimated]);

  const startCounter = () => {
    let startTime = null;
    const increment = end / (duration / 16); // 60fps

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = currentTime - startTime;

      if (progress < duration) {
        const currentCount = Math.min(
          end,
          Math.floor(increment * (progress / 16)),
        );
        setCount(currentCount);
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    requestAnimationFrame(animate);
  };

  return (
    <div ref={ref} className="counter-item">
      <div className="counter-number">
        <span className="count">{count}</span>
        <span className="suffix">{suffix}</span>
      </div>
      <div className="counter-label">{label}</div>
    </div>
  );
};

const CounterSection = () => {
  const counters = [
    { end: 1055, label: "HAPPY CLIENTS", suffix: "+" },
    { end: 2065, label: "PROJECT COMPLETE", suffix: "+" },
    { end: 11, label: "AWARD WINNER" },
    { end: 135, label: "VISITED TRADESHOW" },
  ];

  return (
    <section className="counter-section">
      <div className="counter-container">
        <div className="counter-grid">
          {counters.map((counter, index) => (
            <CounterItem
              key={index}
              end={counter.end}
              label={counter.label}
              suffix={counter.suffix}
              duration={index === 2 ? 1500 : 2000} // Shorter duration for smaller number
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CounterSection;
